import Rank from './Rank'

export default Rank
